import { ObservationCycle } from 'types/api/envScales/ObservationCycle';
import { Assessment } from 'types/api/envScales/Assessment';
import { AgeLevel } from 'types/api/envScales/AgeLevel';
import { CycleMetaDataValue } from 'types/api/envScales/CycleMetaDataValue';
import FirstEditionMetaDataContent from './FirstEditionMetaDataContent';
import ITSecondEditionMetaDataContent from './ITSecondEditionMetaDataContent';
import SecondEditionMetaDataContent from './SecondEditionMetaDataContent';
import ITMetaDataContent from './ITMetaDataContent';
import useFeatureFlags from 'hooks/useFeatureFlags';

interface MetaDataCLASSCyclesProps {
  /** Observation Cycle. */
  cycle: ObservationCycle;

  /** CLASS Assessment. */
  assessment: Assessment;

  /** Environmental Scales Age Level. */
  ageLevel: AgeLevel;

  /** Observation ID */
  observationId: number;

  /** Meta data values */
  values: CycleMetaDataValue[];
}

/**
 * Factory component that renders the appropriate content
 * based on assessment class version and age level
 */
function MetaDataCLASSCycles({
  assessment,
  cycle,
  ageLevel,
  observationId,
  values
}: MetaDataCLASSCyclesProps) {
  const isClassFirstEdition =
    assessment.assessment_template.class_version === 1;
  const isClassSecondEdition =
    assessment.assessment_template.class_version === 2;
  const isInfantToddler = ageLevel.abbreviation === 'IT';
  const { isFeatureFlagEnabled } = useFeatureFlags();

  if (isClassFirstEdition) {
    return (
      <FirstEditionMetaDataContent
        assessment={assessment}
        cycle={cycle}
        ageLevel={ageLevel}
        observationId={observationId}
        values={values}
      />
    );
  }

  if (isClassSecondEdition && isInfantToddler) {
    if (isFeatureFlagEnabled('it_data_collection')) {
      return (
        <ITMetaDataContent
          assessment={assessment}
          cycle={cycle}
          ageLevel={ageLevel}
          observationId={observationId}
          values={values}
        />
      );
    }

    return (
      <ITSecondEditionMetaDataContent
        assessment={assessment}
        cycle={cycle}
        ageLevel={ageLevel}
        observationId={observationId}
        values={values}
      />
    );
  }

  if (isClassSecondEdition) {
    return (
      <SecondEditionMetaDataContent
        assessment={assessment}
        cycle={cycle}
        ageLevel={ageLevel}
        observationId={observationId}
        values={values}
      />
    );
  }

  return null;
}

export default MetaDataCLASSCycles;
